import { Recommendation as RecommendationType } from "../../types";
import Quote from "../Quote/Quote";
import { getQuoteName } from "../../lib/getQuoteName";
import { InvisibleLink } from "../Link/Link";
import { fixNewlines } from "@/lib/text";
import Card from "../Card/Card";

const Recommendation = ({ recommendation }: { recommendation: Omit<RecommendationType, "id" | "respondedAt"> & { respondedAt?: string } }) => {
  return (
    <InvisibleLink href={`/survey/${recommendation.surveyId}`}>
      <Card>
        <Quote
          date={recommendation.respondedAt}
          from={getQuoteName(recommendation.recommendationName, recommendation.recommendationTitle, recommendation.email)}
        >
          {fixNewlines(recommendation.recommendation || "")}
        </Quote>
      </Card>
    </InvisibleLink>
  );
};

export default Recommendation;
